import { formatDate, Modal, SubmitButton } from "@xola/ui-kit";
import { DateFormat } from "common";
import React from "react";
import { Event, Experience, Timeslot } from "types";
import { useResource } from "../../hooks/useResource";
import { SecondaryButton } from "../Common/SecondaryButton";
import { Loader } from "../Loader";

interface BlackoutEventModalProps {
    timeslot: Timeslot;
    onClose: () => void;
    isOpen: boolean;
    isLoading: boolean;
    onConfirm: () => void;
    event?: Event;
}

export const BlackoutEventModal = ({
    timeslot,
    onClose,
    isOpen,
    isLoading,
    onConfirm,
    event,
}: BlackoutEventModalProps) => {
    const blackoutFormatted = formatDate(timeslot.arrivalDatetime, DateFormat.DATE_TIME);
    const { data: experience, isLoading: isLoadingProduct } = useResource<Experience>([
        "products",
        event?.experience.id,
    ]);

    if (isLoadingProduct) {
        return <Loader />;
    }

    return (
        <Modal isOpen={isOpen} onClose={onClose}>
            <Modal.Header>Blackout Event</Modal.Header>
            <Modal.Body>
                <div className="space-y-4" data-testid="blackout-event-modal-message">
                    <p className="p1">
                        A blackout schedule will be created for{" "}
                        <strong>
                            <var data-var="blackoutFormatted">{blackoutFormatted}</var>
                        </strong>
                        . This event will no longer accept reservations, however existing reservations will be retained.
                    </p>
                    <p className="p1">
                        To get this capacity back, you may delete the blackout schedule from{" "}
                        {experience?.name ? <var data-var="experienceName">{experience.name}</var> : "event"} settings.
                    </p>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <SecondaryButton onClick={onClose}>Cancel</SecondaryButton>
                <SubmitButton color="danger" isLoading={isLoading} onClick={onConfirm}>
                    Confirm
                </SubmitButton>
            </Modal.Footer>
        </Modal>
    );
};
